<template>
  <div id="csContainer">

          <el-col size="small " class="speed">
              <el-autocomplete
                      class="inline-input"
                      size="small"
                      v-model="location"
                      :fetch-suggestions="querySearch"
                      placeholder="请输入地点"
                      @select="handleSelect"
              ></el-autocomplete>
          </el-col>
<!--      <el-input size="small " class="speed" placeholder="输入搜索地点: " v-model = 'location' clearable></el-input>-->
      <el-button   class="submit" @click="findPin()" size="small "slot="append" icon="el-icon-search" type="primary" >搜索</el-button>

  </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'headMap',
        data(){
            return{
                restaurants: [],
                isShow: false,
                viewer: null,
                location: null
            }
        },
        mounted(){
            this.init();
            this.restaurants = this.loadAll();
        },
        methods:{
            init(){
                let viewer = util.getViewer("csContainer",{
                    infoBox: true,
                    selectionIndicator: true,
                    homeButton: false,
                    sceneModePicker: false,
                    baseLayerPicker: false,
                });
                this.viewer = viewer;
                let  cf = new Cesium.Cartesian3(-4107046.6468334734, 15755722.58519879, 12073099.956117895)  ;

                this.viewer.camera.setView({
                    destination :cf,
                    orientation : {
                        heading : 6.21390483292924,
                        pitch : -1.5664340610879344,
                        roll : 0.0
                    }
                });

                let pinBuilder = new Cesium.PinBuilder();

                let bankPin = Cesium.when(pinBuilder.fromMakiIconId('bank', Cesium.Color.GOLD, 50), function(canvas) {
                    return viewer.entities.add({
                        id : '建设银行',
                        name : '建设银行',
                        description:'经纬度：-75.1705217, 39.921786' ,
                        position : Cesium.Cartesian3.fromDegrees(-75.1705217, 39.921786),
                        billboard : {
                            image : canvas.toDataURL(),
                            verticalOrigin : Cesium.VerticalOrigin.BOTTOM
                        }
                    });
                });


                let schoolPin = Cesium.when(pinBuilder.fromMakiIconId('school', Cesium.Color.GREEN, 50), function(canvas) {
                    return viewer.entities.add({
                        id: '幸福学校',
                        name : '幸福学校 ',
                        description:'经纬度：-75.1698529, 39.9220071' ,
                        position : Cesium.Cartesian3.fromDegrees(-75.1698529, 39.9220071),
                        billboard : {
                            image : canvas.toDataURL(),
                            verticalOrigin : Cesium.VerticalOrigin.BOTTOM
                        }
                    });
                });


                let url = Cesium.buildModuleUrl('img/market.png');

                let groceryPin = Cesium.when(pinBuilder.fromUrl(url, Cesium.Color.ROYALBLUE, 50),function (canvas) {
                    return viewer.entities.add({
                        id: '众邦商店',
                        name : '众邦商店',
                        description:'经纬度：-75.170726, 39.9208667' ,
                        position : Cesium.Cartesian3.fromDegrees(-75.170726, 39.9208667),
                        billboard : {
                            image : canvas.toDataURL(),
                            verticalOrigin : Cesium.VerticalOrigin.BOTTOM
                        }
                    });
                });
                let hospitalPin = Cesium.when(pinBuilder.fromMakiIconId('hospital', Cesium.Color.RED, 50), function(canvas) {
                    return viewer.entities.add({
                        id: '空军医院',
                        name : '空军医院',
                        description:'经纬度：-75.1698606, 39.9211275' ,
                        position : Cesium.Cartesian3.fromDegrees(-75.1698606, 39.9211275),
                        billboard : {
                            image : canvas.toDataURL(),
                            verticalOrigin : Cesium.VerticalOrigin.BOTTOM
                        }
                    });
                });


                // Cesium.when.all([bankPin,schoolPin, groceryPin, hospitalPin], function(pins){
                //     viewer.zoomTo(pins);
                // });

            },
            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            loadAll() {
                return [
                    { "value": "建设银行", "address": "长宁区新渔路144号" },
                    { "value": "幸福学校", "address": "上海市长宁区淞虹路661号" },
                    { "value": "众邦商店", "address": "上海市普陀区真北路988号创邑金沙谷6号楼113" },
                    { "value": "空军医院", "address": "天山西路438号" },
                ];
            },
            handleSelect(item) {
                console.log(item);
            },

            findPin(){
                let entity = this.viewer.entities.getById(this.location);
                if(entity !== undefined){

                    // this.viewer.trackedEntity = entity;
                    this.viewer.flyTo(entity);
                }else {
                    this.$alert('未搜索到该地点', {
                        confirmButtonText: '确定',
                    });
                }

            }

        }
    }
</script>
<style scoped>
    .speed{
        position: absolute;
        width:112px;
        margin-left: 15px;
        margin-top:7px;
        z-index: 999;
    }
    .submit {
        position: absolute;
        padding :8px;
        margin-left: 135px;
        margin-top:8px;
        z-index: 999;
    }
  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
